<template>
  <v-main id="cenas">
    <v-container fluid>
      <div>
        <v-btn
          depressed
          color="#D8E0E6"
          class="gray-button pag-btn return-btn"
          to="/login"
          ><v-icon size="10" left>$icon-arrow-left</v-icon> Voltar</v-btn
        >
      </div>
      <v-row style="height: 100%;">
        <!-- LEFT COLUMN -->
        <v-col class="left-col flex-center">
          <div style="width: 100%;">
            <v-row>
              <v-col>
                <v-img
                  src="../assets/images/password.png"
                  aspect-ratio="1"
                  contain
                ></v-img>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- RIGHT COLUMN -->
        <v-col class="right-col flex-center">
          <!-- LOGO -->
          <div class="logo">
            <v-img src="../assets/images/logo.svg"></v-img>
          </div>
          <div>
            <!-- BANNER IMAGE -->
            <v-row class="login-img" align="center" justify="center">
              <v-col
                cols="10"
                style="padding: 0"
                align="center"
                justify="center"
              >
                <img
                  src="../assets/images/password.png"
                  style="width:100%; max-width: 312px;"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="form-header">
                <div class="text-center big-title">
                  Não fique
                  <a>fora de jogo.</a>
                </div>
                <div class="text-center small-title">
                  Recupere a sua a password através do email associado à sua
                  conta e volte a entrar em campo.
                </div>
              </v-col>
            </v-row>
            <!-- FORM -->
            <v-form ref="form" lazy-validation>
              <!-- EMAIL -->
              <v-row align="center" justify="center">
                <v-col class="form-col" style="padding-bottom:4px !important;">
                  <v-text-field
                    filled
                    dense
                    height="48"
                    placeholder="Email associado"
                    :hide-details="!input.email.error"
                    :error-messages="input.email.errorText"
                    name="username"
                    type="email"
                    class="login-register-text"
                    v-model="input.email.value"
                    :append-icon="
                      input.email.error
                        ? '$icon-circle-error'
                        : input.email.valid
                        ? '$icon-circle-check'
                        : ''
                    "
                    @input="validateEmail(false)"
                    v-bind:class="{
                      'input-success': input.email.valid,
                      'input-error': input.email.error
                    }"
                  ></v-text-field>
                </v-col>
              </v-row>
              <div class="form-actions">
                <!-- RECOVER BUTTON -->
                <v-row align="center" justify="center">
                  <v-col class="flex-center">
                    <v-dialog max-width="349" v-model="showDialog">
                      <v-card>
                        <v-card-title align="center">
                          Mister, faça uma
                          <a>substituição</a>.
                        </v-card-title>
                        <v-card-text
                          >Contra-ataque em campo. Verifique o seu email.
                          Enviamos-lhe um link para recuperar a sua
                          password.</v-card-text
                        >
                        <v-list-item style="padding-bottom: 12px;">
                          <v-list-item-content class="flex-center">
                            <v-btn
                              class="green-btn"
                              depressed
                              color="primary"
                              height="40"
                              to="/login"
                              >Ir para página de login</v-btn
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-card>
                    </v-dialog>
                    <v-btn
                      large
                      depressed
                      color="primary"
                      class="regular-btn"
                      :loading="loading"
                      @click="validate()"
                      >Submeter</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="snackBarTimeout" color="error">{{
      errorText
    }}</v-snackbar>
  </v-main>
</template>

<style scoped>
.v-main {
  height: calc(100vh - 2px);
  padding: 0px 256px 0px 0px;
  position: absolute;
  width: 100vw;
  top: -14px;
  padding: 0 !important;
  left: 0;
}
.container {
  height: 100%;
  padding: 0 !important;
}
.left-col {
  flex: 0 0 45%;
  max-width: 45%;
}
.return-btn {
  position: fixed;
  top: 24px;
  left: 32px;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #9aabb8;
  text-transform: capitalize;
  width: 176px;
  z-index: 99;
}
.right-col {
  flex: 0 0 55%;
  max-width: 55%;
  background-color: #ffffff;
}
.form-header {
  flex: 0 0 300px;
  max-width: 300px;
}
.big-title {
  font-family: Gilroy-SemiBold;
  font-size: 20px;
  line-height: 24px;
}
.small-title {
  font-family: Gilroy-SemiBold;
  color: #6d818f;
  font-size: 14px;
  line-height: 16px;
}
.v-list-item {
  min-height: initial !important;
}
.light-text {
  color: #bcc5cc !important;
  font-size: 12px;
  line-height: 16px;
}
.align-bottom {
  margin-top: 0;
}
.v-image >>> .v-responsive__sizer {
  max-height: 250px !important;
}
.logo {
  position: absolute;
  left: calc(72.5% - 31px);
  top: 136px;
}
.login-img {
  display: none;
}
.form-col {
  flex: 0 0 380px;
  max-width: 380px;
}
.form-actions {
  margin-top: 32px;
}
@media only screen and (max-width: 768px) {
  .left-col {
    display: none;
  }
  .right-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .login-img {
    display: flex;
  }
  .return-btn {
    width: 106px;
  }
  .form-col {
    flex: 0 0 90%;
    max-width: 90%;
  }
  .logo {
    position: absolute;
    left: 50%;
    top: 84px;
  }
  .logo .v-image {
    position: relative;
    left: -50%;
  }
  .form-actions {
    position: absolute;
    left: 50%;
  }
  .form-actions .row {
    position: relative;
    left: -50%;
  }
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #26ab5e !important;
  color: #ffffff !important;
}
.v-btn:not(.v-btn--round).v-size--large {
  height: 48px;
}
</style>

<script>
import { FirebaseApp } from "../auth";
import ApiService from "@/services/api.service";

export default {
  props: {
    source: String
  },
  components: {},
  data: () => ({
    errorText: "",
    showDialog: false,
    showPassword: false,
    snackbar: false,
    snackBarTimeout: 3000,
    loading: false,
    input: {
      email: {
        value: "",
        valid: false,
        error: false,
        errorText: ""
      }
    },
    rules: {
      required: v => !!v || "Este campo é obrigatório",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: v => /.+@.+\..+/.test(v) || "Email inválido"
    }
  }),
  methods: {
    validate() {
      if (this.validateEmail(true)) {
        this.recover();
      }
    },
    validateEmail(fromButton) {
      if (/.+@.+\..+/.test(this.input.email.value)) {
        this.input.email.valid = true;
        this.input.email.error = "";
        return true;
      } else {
        this.input.email.valid = false;
        if (fromButton) {
          this.input.email.error = true;
          this.input.email.errorText = "Email inválido";
        }
        return false;
      }
    },
    recover() {
      this.loading = true;

      FirebaseApp.auth()
        .sendPasswordResetEmail(this.input.email.value)
        .then(() => {
          this.loading = false;
          this.showDialog = true;
          this.input.email.value = "";
        })
        .catch(error => {
          this.loading = false;
          if (
            error.code === "auth/wrong-password" ||
            error.code === "auth/user-not-found" ||
            error.code === "auth/invalid-email"
          ) {
            this.input.email.errorText = "O email é inválido!";
            this.input.email.error = true;
          } else if (error.code === "auth/too-many-requests") {
            this.errorText =
              "Demasiadas tentativas sem êxito. Por favor, tente mais tarde.";
            this.snackbar = true;
          } else {
            this.errorText = "Erro ao contactar o servidor. pedimos desculpas!";
            this.snackbar = true;
          }

          console.error(error);
          console.log(this.errorText);
          return false;
        });
    }
  }
};
</script>